'use strict';
define([], function () {


    return {
        templateUrl: 'app/modules/seochecker/components/word-cloud/word-cloud.html',
        bindings: {
            overview: '<',
            loading: '<'
        },
        controller: ['$scope', '$element', '$timeout', '$window', 'angularLoad', function ($scope, $element, $timeout, $window, angularLoad) {
            var vm = $scope;
            var keywordList = [];
            var scriptsReady = false;

            this.$onInit = function() {
                angularLoad.loadScript('./app/vendors/d3.min.js')
                    .then(function(){
                        return angularLoad.loadScript('./app/vendors/d3.layout.cloud.js');
                    })
                    .then(function(){
                        return angularLoad.loadScript('./app/vendors/d3.wordcloud.js?v=20261103-wordcloud-2');
                    })
                    .then(function(){
                        scriptsReady = true;
                        renderCloud();
                    });
            };

            this.$onChanges = function() {
                vm.loading = this.loading;
                vm.relevantKeywords = [];
                keywordList = [];

                if (this.overview && this.overview.relevantKeywords) {
                    vm.relevantKeywords = this.overview.relevantKeywords;
                    vm.wordCount = this.overview.wordCount;
                    vm.readingTime = this.overview.readingTime;

                    for (var i=0; i<vm.relevantKeywords.length; i+=1) {
                        keywordList.push({
                            "text": vm.relevantKeywords[i].word,
                            "size": vm.relevantKeywords[i].count
                        });
                    }
                    keywordList.sort(function(a, b) {
                        return b.size - a.size;
                    });
                }

                renderCloud();
            };

            function renderCloud() {
                if (!scriptsReady || !keywordList.length || !$window.d3) {
                    return;
                }

                $timeout(function(){
                    var cloudElement = $element[0].querySelector('#wordcloud');
                    if (!cloudElement) {
                        return;
                    }

                    var existingSvg = cloudElement.querySelector('svg');
                    if (existingSvg) {
                        existingSvg.parentNode.removeChild(existingSvg);
                    }

                    var cloudWidth = Math.max(260, Math.min(450, cloudElement.getBoundingClientRect().width || 450));
                    var palette = [
                        'var(--sto-color-primary)',
                        'var(--sto-color-text)',
                        'var(--sto-color-text-muted)',
                        'var(--sto-color-success)'
                    ];
                    var colorForWord = function(word) {
                        var hash = 0;
                        for (var i = 0; i < word.length; i += 1) {
                            hash += word.charCodeAt(i);
                        }
                        return palette[hash % palette.length];
                    };

                    $window.d3.wordcloud()
                        .size([cloudWidth, 300])
                        .fontSizeRange([11, 38])
                        .font('Figtree')
                        .fontWeight(600)
                        .rotate(0)
                        .padding(3)
                        .fill(colorForWord)
                        .words(keywordList)
                        .onwordclick(function(d, i) {
                            if (d.href) { window.location = d.href; }
                        })
                        .start();
                }, 0, false);
            }
        }]
    };
});
